import React from 'react';
import MdiIcon from '@mdi/react';
import { getIconPath } from './iconMap';

/**
 * Wrapper MDI — paridade com MaterialCommunityIcons do app.
 * @param {string} name - kebab-case ou snake_case
 */
/** @mdi/react usa número como fator rem (1.5×n rem), não pixels — normalizamos para px. */
function resolveMdiSize(size) {
  if (typeof size === 'string') {
    return size;
  }
  if (typeof size === 'number' && !Number.isNaN(size)) {
    return `${size}px`;
  }
  return '24px';
}

const Icon = ({ name, size = 24, color = 'currentColor', className, spin, title, style }) => {
  const path = getIconPath(name);
  if (!path) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[Icon] não encontrado: ${name}`);
    }
    return null;
  }
  return (
    <MdiIcon
      path={path}
      size={resolveMdiSize(size)}
      color={color}
      className={className}
      spin={spin}
      title={title}
      style={style}
    />
  );
};

export default Icon;
